<template>
  <div class="AdvertisingModalLeft d-flex flex-column">
    <div class="flex-grow-1">
      <h1 class="AdvertisingModalLeft_title">
        {{ $t('advertising.title') }}
      </h1>
      <p class="text-justify">
        {{ $t('advertising.text-1') }}
      </p>
      <p class="text-justify">
        {{ $t('advertising.text-2') }}
      </p>
      <p class="text-justify">
        {{ $t('advertising.text-3') }}
      </p>
    </div>
    <div class="d-flex justify-end">
      <a
        :href="leftButtonUrl"
        target="_blank"
        class="theme-button app-button-secondary-alt color nice-padding nice-radius mr-6 d-flex align-center"
      >
        {{ $t('advertising.button-left') }}
      </a>
      <a
        :href="rightButtonUrl"
        target="_blank"
        class="theme-button app-button-primary color nice-padding nice-radius d-flex align-center"
      >
        {{ $t('advertising.button-right') }}
        <v-icon
          right
          dark
        >
          mdi-arrow-right
        </v-icon>
      </a>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      leftButtonUrl: {
        type: String,
        required: true,
      },
      rightButtonUrl: {
        type: String,
        required: true,
      },
    },
  }
</script>

<style scoped lang="scss">
.AdvertisingModalLeft {
  font-size: 20px;

  &_title {
    font-size: 48px;
    font-weight: bold;
    margin: 0 0 52px 0;
  }
}
</style>
